import { render, staticRenderFns } from "./WangEditorPreview.vue?vue&type=template&id=1640f822&scoped=true&"
import script from "./WangEditorPreview.vue?vue&type=script&lang=js&"
export * from "./WangEditorPreview.vue?vue&type=script&lang=js&"
import style0 from "./WangEditorPreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WangEditorPreview.vue?vue&type=style&index=1&id=1640f822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640f822",
  null
  
)

export default component.exports